import { WizardBody } from 'src/components/DUP/atoms/WizardBody';
import { Success } from 'src/components/DUP/molecules/Success';
import WizardFooter from 'src/components/DUP/molecules/WizardFooter';
import WizardFormApplicant from 'src/components/DUP/molecules/WizardFormApplicant';
import { WizardHeader } from 'src/components/DUP/molecules/WizardHeader';
import WizardProofOfIncome from 'src/components/DUP/molecules/WizardProofOfIncome/WizardProofOfIncome';
import { WizardSubmit } from 'src/components/DUP/molecules/WizardSubmit';
import { WizardSupportingDocuments } from 'src/components/DUP/molecules/WizardSupportingDocuments/WizardSupportingDocuments';
import { useApplication } from 'src/context/ApplicationContext';
import { StepId } from 'src/hooks/useWizardSteps';
import { WizardContainer } from 'src/pages/DUPPage/styles';

// Use this type to define the props for each of the sub-components in the DUP wizard
export interface DupScreenStepProps {
  onFinished: () => void;
  goBack: () => void;
  activeStepIdx: number;
  setActiveStepIdx: (idx: number) => void;
}

export const SNAX_APP_TITLE = 'Snappt AX';

/**
 * This component is the main entry point for the DUP wizard.
 * It will display the header, footer, and the various steps in the wizard.
 */
export const DUPWizard = () => {
  const {
    steps: { activeStepIdx, RequiredDocsModal, onFinished }
  } = useApplication();

  const wizardComponents = [
    <WizardFormApplicant key={0} />,
    <WizardProofOfIncome key={1} />,
    <WizardSupportingDocuments key={2} />,
    <WizardSubmit key={3} />,
    <Success key={4} />
  ];

  return (
    <>
      <RequiredDocsModal handleNext={onFinished} />
      <WizardContent>{wizardComponents[activeStepIdx]}</WizardContent>
    </>
  );
};

const WizardContent = ({ children }: { children: JSX.Element }) => {
  const {
    steps: { activeStepIdx, info, activeStepId }
  } = useApplication();
  const step = info[activeStepIdx];
  const stepInfoAttributes = step ? step.stepInfoAttributes : {};

  return (
    <WizardContainer {...stepInfoAttributes}>
      <WizardHeader />
      <WizardBody activeStep={activeStepIdx}>
        {children}
        {activeStepId !== StepId.Success && <WizardFooter hideOn="desktop" />}
      </WizardBody>
      {activeStepId !== StepId.Success && <WizardFooter hideOn="mobile" />}
    </WizardContainer>
  );
};
